$(document).ready(function () {
    changeCTALabel();
    checkVariantAvailability('#product-data', '.prod_swatch--input');
    checkVariantAvailability('#bundle_product-data', '.bundle_swatch--input');

    $('.button--add-to-cart').click(function(event) {
        bundle(event);
    });

    $('.swatch_options label').click(function() {
        var imageUrl = $(this).data('image');
        if (imageUrl) $('#main_product_image').attr('src', imageUrl);
    });

    $('.bundle_swatch_options label').click(function() {
        var imageUrl = $(this).data('image');
        if (imageUrl) $('#bundle_product_image').attr('src', imageUrl);
    });
});


$("input[name='option1']").on("change", function() {
    const checkedValue = $(this).val();
    const productData = JSON.parse($('#product-data').html());
    let availableVariantId = productData.variants
    .filter(function (variant) {
      return variant.available === true && variant.option1 === checkedValue;
    })
    .map(function (variant) {
      return variant;
    });
    const option2Inputs = $("input[name='option2']");
    updateOptionAvailability(option2Inputs, availableVariantId, 'option2');
});

$("input[name='bundle_option-0']").on("change", function() {
    const checkedValue = $(this).val();
    const bundleProductData = JSON.parse($('#bundle_product-data').html());
    let availableBundleVariantId = bundleProductData.variants
    .filter(function (variant) {
      return variant.available === true && variant.option1 === checkedValue;
    })
    .map(function (variant) {
      return variant;
    });

    const option1Inputs = $("input[name='bundle_option-1']");
    updateOptionAvailability(option1Inputs, availableBundleVariantId, 'option2')
});

function checkVariantAvailability(dataElementId, swatchInputSelector) {
    const productData = JSON.parse($(dataElementId).html());
    let firstAvailableVariant = productData.variants.find(variant => variant.available === true);
    if (firstAvailableVariant) {
        let element = $(swatchInputSelector).filter(function () {
            return $(this).val() === firstAvailableVariant.option1;
        });
        if (element.length) {
            element.prop("checked", true).trigger("change");
        }
    }
}

function updateOptionAvailability(inputs, availableVariants, optionKey) {
    let firstAvailableOption = null;
    inputs.each(function (input) {
        const inputValue = $(this).val();
        const isAvailable = availableVariants.some(variant => variant[optionKey] === inputValue);
        const statusDiv = $(this).next("div");
        if (isAvailable) {
            if(!firstAvailableOption){
                $(this).prop("checked", true);
                firstAvailableOption = $(this)
            }
            statusDiv.removeClass('soldout').addClass('available');
            $(this).prop("disabled", false);
        } else {
            $(this).prop("checked", false);
            statusDiv.removeClass('available').addClass('soldout');
            $(this).prop("disabled", true);
        }
    });
}

function changeCTALabel(){
    const productData = JSON.parse($('#product-data').html());
    const bundleProductData = JSON.parse($('#bundle_product-data').html());
    if(!productData.available && bundleProductData.available){
        $('#talentless-bundle-cta').html( "Add " + bundleProductData.title);
    }
    if(productData.available && !bundleProductData.available){
        $('#talentless-bundle-cta').html("Add " + productData.title);
    }
    if(!productData.available && !bundleProductData.available){
        $('#talentless-bundle-cta').html("Out of stock");
        $("#talentless-bundle-cta").prop("disabled", true);
    }
   
}

function bundle(event) {
    event.preventDefault();
    const productData = JSON.parse($('#product-data').html());
    const bundleProductData = JSON.parse($('#bundle_product-data').html());
    let lineItems= [];
    if(productData.available){
        let option1 = $('.swatch_options input:checked').eq(0).val();
        let option2 = $('.swatch_options input:checked').eq(1).val() || null;
        let option3 = $('.swatch_options input:checked').eq(2).val() || null;

        // console.log(option1, option2, option3)

        let variantId = productData.variants.find(function (variant) {
            return variant.option1 === option1 && variant.option2 === option2 && variant.option3 === option3;
        })?.id;

        if(variantId){
            lineItems.push({
                quantity: 1,
                id: variantId,
                properties: {
                    '_attribution': 'talentless-bundle',
                    '_attribution': 'talentless-top'
                }
            })
        }
    }

    if(bundleProductData.available){
        let bundle_option1 = $('.bundle_swatch_options input:checked').eq(0).val();
        let bundle_option2 = $('.bundle_swatch_options input:checked').eq(1).val() || null;
        let bundle_option3 = $('.bundle_swatch_options input:checked').eq(2).val() || null;

        let bundleVariantId = bundleProductData.variants.find(function (variant) {
            return variant.option1 === bundle_option1 && variant.option2 === bundle_option2 && variant.option3 === bundle_option3;
        })?.id;

        if(bundleVariantId){
            lineItems.push({
                quantity: 1,
                id: bundleVariantId,
                properties: {
                    '_attribution': 'talentless-bundle',
                    '_attribution': 'talentless-bottom'
                }
            })
        }
    }

    // //Ajax request to add special item to cart

    if(lineItems.length){
        $.ajax({
            type: "POST",
            url: '/cart/add.js',
            data: {
                items:lineItems
            },
            async: false,
        })
    }
}